export default __webpack_public_path__ + "static/media/3.91abc696.jpeg";